function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { WKVOD } from './vod';

var VodUploader = /*#__PURE__*/function () {
  function VodUploader(baseURL) {
    _defineProperty(this, "vod", void 0);

    _defineProperty(this, "uploaer", void 0);

    this.vod = new WKVOD(baseURL);
  }

  var _proto = VodUploader.prototype;

  _proto.upload = /*#__PURE__*/function () {
    var _upload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var file, options, onProgress, cover, initRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = _ref.file, options = _ref.options, onProgress = _ref.onProgress, cover = _ref.cover;

              if (options) {
                _context.next = 3;
                break;
              }

              throw new Error('class is required');

            case 3:
              _context.next = 5;
              return this.vod.init(file, options);

            case 5:
              initRes = _context.sent;
              this.uploaer = this.vod.upload(file, cover);
              this.uploaer.on('media_progress', function (_ref2) {
                var percent = _ref2.percent;
                return onProgress && onProgress({
                  percent: percent
                });
              });
              return _context.abrupt("return", this.uploaer.done().then(function (result) {
                return {
                  file_id: result.fileId,
                  verify_content: result.video.verify_content,
                  url: result.video.url,
                  cover: result.cover ? result.cover.url : null,
                  file: _extends({}, initRes.file, {
                    sub_app_id: initRes.sub_app_id
                  })
                };
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function upload(_x) {
      return _upload.apply(this, arguments);
    }

    return upload;
  }() //取消请求
  ;

  _proto.cancel =
  /*#__PURE__*/
  function () {
    var _cancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.uploaer.cancel();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function cancel() {
      return _cancel.apply(this, arguments);
    }

    return cancel;
  }();

  return VodUploader;
}();

export { VodUploader as default };


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/vod/index.js
// module id = 645
// module chunks = 4